export default "__VITE_ASSET__b5d3d376__"